export default __webpack_public_path__ + "static/media/tile-term.0825bf5b.png";